export default __webpack_public_path__ + "static/media/Opus of Ash and Blood.dae4d802.jpg";